<template>

  <div id="content" class="content">
    <div class="content__text-block">
      <h1 class="h1">Anmälan</h1>
      <p>
        Anmälan till 2024 års Säter Triathlon är öppen
      </p>
    </div>
    <div class="content__button-block">
      <a href="https://mittlopp.se/Anmalan/Arrangemangsgrupp/KQBZIHUGFEJASCYHSZ">
        <button class="content__register-button">Till Anmälan</button>
      </a>
      <a href="https://mittlopp.se/startlista/KQBZIHUGFEJASCYHSZ">
        <button class="content__registred-button">Anmälda</button>
      </a>
    </div>
  </div>
</template>

<script>


export default {
  Name: 'Registration',
  components: {
  },

  mounted() {

  }
}
</script>

<style lang="scss" scoped>

.content{

  &__text-block {
    width: 75%;
    margin-right: 50px;
  }

  &__button-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // min-width: 200px;
    border-left: 1px solid black;
    min-height: 200px;
  }

  &__register-button {
    cursor: pointer;
    margin-left: 50px;
    width: 200px;
    height: 75px;
    border-radius: 50px;
    background-color: #4289b9;
    font-size: 20px;
    color: white;
    border: none;
    box-shadow: 1px 1px 8px #c8c8c8;

    &:hover {
      background-color: #2f7fb5;
    }

    &:active {
      background-color: #1673b1;
    }

    &:disabled {
      background-color: gray;
      cursor: not-allowed;
    }
  }

  &__registred-button {
    margin-top: 30px;
    margin-left: 50px;
    width: 200px;
    height: 75px;
    background-color: transparent;
    font-size: 20px;
    color: black;
    border: none;

    &:hover {
      color: rgb(93, 93, 93);
      cursor: pointer;
    }
  }

  @media only screen and (max-width:650px) {
    flex-direction: column;

    &__text-block {
      margin: auto;
    }
    &__button-block {
      border-left: none;
      border-top: 1px solid black;
    }
    &__register-button {
      margin: auto;
    }
  }
}

.h1 {
  font-size: 50px
}
</style>